export default {
  modelName: 'industry_category',
  label: '產業類型',
  fields: {
    area: {
      type: 'belongsTo',
      label: '地區',
      rules: 'required',
      textKey: 'name',
      modelName: 'area',
      clearable: true,
    },
    locales: {
      type: 'locales',
      // label: "多語言內容",
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 30,
        },
      },
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    // updated_info: {
    //   type: "custom",
    //   label: "上次修改時間",
    //   readonly: true,
    //   getValue: (item) => {
    //     let _value = item.updated_at;
    //     if (item.updated_admin) {
    //       _value += `  ${item.updated_admin}`;
    //     }
    //     return _value;
    //   },
    // },
  },
};
